/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UiConfigAPI {

  /**
   * Returns the UI config used by default
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAdminUiConfigDefault(): CancelablePromise<{
    version: string;
    domain: string;
    page_title?: string;
    cdnUrl: string;
    font: {
      googleFamily: string;
      weightLight: number;
      weightRegular: number;
      weightMedium: number;
      weightBold: number;
    };
    colors: {
      error: {
        light: string;
        dark: string;
      };
      primary: {
        light: string;
        dark: string;
      };
      secondary: {
        light: string;
        dark: string;
      };
      primary2: {
        light: string;
        dark: string;
      };
      borderDisabled: {
        light: string;
        dark: string;
      };
      backgroundDefault: {
        light: string;
        dark: string;
      };
      backgroundPaper: {
        light: string;
        dark: string;
      };
      border: {
        light: string;
        dark: string;
      };
      boxShadow: {
        light: string;
        dark: string;
      };
      form: {
        light: string;
        dark: string;
      };
      textSpecial: {
        light: string;
        dark: string;
      };
      textForm: {
        light: string;
        dark: string;
      };
      textDisabled: {
        light: string;
        dark: string;
      };
      textPrimary: {
        light: string;
        dark: string;
      };
      textSecondary: {
        light: string;
        dark: string;
      };
      textPrimary2: {
        light: string;
        dark: string;
      };
    };
    images: {
      logoBig: {
        lightUrl: string;
        darkUrl: string;
      };
      logoSmall: {
        lightUrl: string;
        darkUrl: string;
      };
      login: {
        lightUrl: string | null;
        darkUrl: string | null;
      };
      favicon: {
        lightUrl: string;
        darkUrl: string;
      };
    };
    translations: {
      menuTitle: {
        en: string;
        es: string;
        fr: string;
        ar: string;
      };
    };
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/ui-config-default',
    });
  }

  /**
   * Returns the UI config for the current domain
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAdminUiConfig(): CancelablePromise<{
    version: string;
    domain?: string;
    page_title?: string;
    cdnUrl?: string;
    font: {
      googleFamily: string;
      weightLight: number;
      weightRegular: number;
      weightMedium: number;
      weightBold: number;
    };
    colors: {
      error: {
        light: string;
        dark: string;
      };
      primary: {
        light: string;
        dark: string;
      };
      secondary: {
        light: string;
        dark: string;
      };
      primary2: {
        light: string;
        dark: string;
      };
      borderDisabled: {
        light: string;
        dark: string;
      };
      backgroundDefault: {
        light: string;
        dark: string;
      };
      backgroundPaper: {
        light: string;
        dark: string;
      };
      border: {
        light: string;
        dark: string;
      };
      boxShadow: {
        light: string;
        dark: string;
      };
      form: {
        light: string;
        dark: string;
      };
      textSpecial: {
        light: string;
        dark: string;
      };
      textForm: {
        light: string;
        dark: string;
      };
      textDisabled: {
        light: string;
        dark: string;
      };
      textPrimary: {
        light: string;
        dark: string;
      };
      textSecondary: {
        light: string;
        dark: string;
      };
      textPrimary2: {
        light: string;
        dark: string;
      };
    };
    images: {
      logoBig: {
        lightUrl: string;
        darkUrl: string;
      };
      logoSmall: {
        lightUrl: string;
        darkUrl: string;
      };
      login: {
        lightUrl: string | null;
        darkUrl: string | null;
      };
      favicon: {
        lightUrl: string;
        darkUrl: string;
      };
    };
    translations: {
      menuTitle: {
        en: string;
        es: string;
        fr: string;
        ar: string;
      };
    };
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/ui-config',
    });
  }

  /**
   * Method that updates the sub domain ui config
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiAdminUiConfig(
    requestBody: {
      version: string;
      domain: string;
      page_title?: string;
      cdnUrl?: string;
      font: {
        googleFamily: string;
        weightLight: number;
        weightRegular: number;
        weightMedium: number;
        weightBold: number;
      };
      colors: {
        error: {
          light: string;
          dark: string;
        };
        primary: {
          light: string;
          dark: string;
        };
        secondary: {
          light: string;
          dark: string;
        };
        primary2: {
          light: string;
          dark: string;
        };
        borderDisabled: {
          light: string;
          dark: string;
        };
        backgroundDefault: {
          light: string;
          dark: string;
        };
        backgroundPaper: {
          light: string;
          dark: string;
        };
        border: {
          light: string;
          dark: string;
        };
        boxShadow: {
          light: string;
          dark: string;
        };
        form: {
          light: string;
          dark: string;
        };
        textSpecial: {
          light: string;
          dark: string;
        };
        textForm: {
          light: string;
          dark: string;
        };
        textDisabled: {
          light: string;
          dark: string;
        };
        textPrimary: {
          light: string;
          dark: string;
        };
        textSecondary: {
          light: string;
          dark: string;
        };
        textPrimary2: {
          light: string;
          dark: string;
        };
      };
      images: {
        logoBig: {
          lightUrl: string;
          darkUrl: string;
        };
        logoSmall: {
          lightUrl: string;
          darkUrl: string;
        };
        login: {
          lightUrl: string | null;
          darkUrl: string | null;
        };
        favicon: {
          lightUrl: string;
          darkUrl: string;
        };
      };
      translations: {
        menuTitle: {
          en: string;
          es: string;
          fr: string;
          ar: string;
        };
      };
    },
  ): CancelablePromise<{
    version: string;
    domain: string;
    page_title?: string;
    cdnUrl: string;
    font: {
      googleFamily: string;
      weightLight: number;
      weightRegular: number;
      weightMedium: number;
      weightBold: number;
    };
    colors: {
      error: {
        light: string;
        dark: string;
      };
      primary: {
        light: string;
        dark: string;
      };
      secondary: {
        light: string;
        dark: string;
      };
      primary2: {
        light: string;
        dark: string;
      };
      borderDisabled: {
        light: string;
        dark: string;
      };
      backgroundDefault: {
        light: string;
        dark: string;
      };
      backgroundPaper: {
        light: string;
        dark: string;
      };
      border: {
        light: string;
        dark: string;
      };
      boxShadow: {
        light: string;
        dark: string;
      };
      form: {
        light: string;
        dark: string;
      };
      textSpecial: {
        light: string;
        dark: string;
      };
      textForm: {
        light: string;
        dark: string;
      };
      textDisabled: {
        light: string;
        dark: string;
      };
      textPrimary: {
        light: string;
        dark: string;
      };
      textSecondary: {
        light: string;
        dark: string;
      };
      textPrimary2: {
        light: string;
        dark: string;
      };
    };
    images: {
      logoBig: {
        lightUrl: string;
        darkUrl: string;
      };
      logoSmall: {
        lightUrl: string;
        darkUrl: string;
      };
      login: {
        lightUrl: string | null;
        darkUrl: string | null;
      };
      favicon: {
        lightUrl: string;
        darkUrl: string;
      };
    };
    translations: {
      menuTitle: {
        en: string;
        es: string;
        fr: string;
        ar: string;
      };
    };
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/ui-config',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that upload a file that will be used for a theme
   * @param formData
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiAdminUiConfigUploadImage(
    formData: {
      file: Blob;
    },
  ): CancelablePromise<{
    relativePath: string;
    absolutePath: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/ui-config/upload-image',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Returns the UI config for the current domain
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUiConfig(): CancelablePromise<{
    version: string;
    domain?: string;
    page_title?: string;
    cdnUrl?: string;
    font: {
      googleFamily: string;
      weightLight: number;
      weightRegular: number;
      weightMedium: number;
      weightBold: number;
    };
    colors: {
      error: {
        light: string;
        dark: string;
      };
      primary: {
        light: string;
        dark: string;
      };
      secondary: {
        light: string;
        dark: string;
      };
      primary2: {
        light: string;
        dark: string;
      };
      borderDisabled: {
        light: string;
        dark: string;
      };
      backgroundDefault: {
        light: string;
        dark: string;
      };
      backgroundPaper: {
        light: string;
        dark: string;
      };
      border: {
        light: string;
        dark: string;
      };
      boxShadow: {
        light: string;
        dark: string;
      };
      form: {
        light: string;
        dark: string;
      };
      textSpecial: {
        light: string;
        dark: string;
      };
      textForm: {
        light: string;
        dark: string;
      };
      textDisabled: {
        light: string;
        dark: string;
      };
      textPrimary: {
        light: string;
        dark: string;
      };
      textSecondary: {
        light: string;
        dark: string;
      };
      textPrimary2: {
        light: string;
        dark: string;
      };
    };
    images: {
      logoBig: {
        lightUrl: string;
        darkUrl: string;
      };
      logoSmall: {
        lightUrl: string;
        darkUrl: string;
      };
      login: {
        lightUrl: string | null;
        darkUrl: string | null;
      };
      favicon: {
        lightUrl: string;
        darkUrl: string;
      };
    };
    translations: {
      menuTitle: {
        en: string;
        es: string;
        fr: string;
        ar: string;
      };
    };
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ui-config',
    });
  }

  /**
   * Returns the UI favicon for the current domain
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUiFavicon(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ui-favicon',
    });
  }

}
